'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.castString = castString;
/**
 * @description Casts strings with java-style casting prefixes to correct types
 * @summary
 * This method checks, if the given string contains a java-style casting prefix (type in braces)
 * and casts that string to the correct type.
 *
 * This allows for easy type conversion in contexts where only strings are valid.
 *
 * Valid types are:
 * - int, integer
 * - float
 * - bool, boolean
 * - string
 *
 * @example
 * import { castString } from '@nimius/string-utility';
 *
 * castString('(int) 5');
 * // => 5
 *
 * castString('(float) 5.2');
 * // => 5.2
 *
 * castString('(bool) true');
 * // => true
 *
 * castString('(string) test');
 * // => 'test'
 *
 * castString('test');
 * // => 'test'
 *
 * @example
 * //
 * // In the HTML:
 * // <div data-someint="(int) 4">...</div>
 * //
 *
 * //
 * // In the JS:
 * //
 * import { castString } from '@nimius/string-utility';
 *
 * const element = document.querySelector('[data-someint]');
 * castString(element.getAttribute('data-someint'));
 * // => 4
 *
 * @param {string} string - The string that should be casted. If the string should be cast, then this string must
 *        contain a java-style casting prefix such as "(bool) false"
 * @return {string|boolean|number|null} - The cast value
 */
function castString(string) {
    string = string.trim();
    var match = string.match(/^\((.*?)\)/);

    // Do not cast, if no casting prefix was found.
    if (!match) {
        return string;
    }

    // Remove braces from the string.
    string = string.substr(match[0].length).trim();

    // Do casting.
    switch (match[1].trim()) {

        case 'int':
        case 'integer':
            return parseInt(string);

        case 'float':
            return parseFloat(string);

        case 'bool':
        case 'boolean':
            if (string === 'false' || string === '0') {
                return false;
            }
            if (string === 'true' || string === '1') {
                return true;
            }
            return !!string;

        case 'string':
        default:
            return string;

    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/string-utility/src/cast-string.js
// module id = 64
// module chunks = 0 2